import useController from "./controller";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useViewController from "./viewController";
import TopMobileModal from "../../modals/TopMobileModal";
import Butterflies from "../../components/Butterflies";
import Ellipses from "../../components/Ellipses";
import ProgressBar from "./components/ProgressBar";
import Game from "../../store/Game";
import Swipe from "react-easy-swipe";
import Swiper from "../../store/Swiper";
import SwiperImage from "./components/SwiperImage";
import CardTitle from "./components/CardTitle";
import LastAnswer from "./components/LastAnswer";
import SwiperActions from "./components/SwiperActions";
import MobileModalLastAnswers from "./components/MobileModalLastAnswers";
import BaseTextButton from "../../components/BaseTextButton";
import BurgerMenu from "../../components/BurgerMenu";
import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react-lite";
import "./style.scss";
import BackButton from "../../components/BackButton";
import BaseButton from "../../components/BaseButton";
import ROUTES from "../../utils/routes.js";
import useAuth from "../../hooks/useAuth";
import WrapperPage from "../../components/WrapperPage";

const mountedStyle = { animation: "inAnimation 0.5s ease-in" };
const unmountedStyle = {
  animation: "outAnimation 0.5s ease-out",
  animationFillMode: "forwards",
};

export default observer(function InGameEditPage() {
  const { onFeedbackSwipe } = useController();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { token } = useAuth();
  const {
    countCard,
    onSwipeStart,
    opacityCard,
    completedCards,
    isPositive,
    isNeutral,
    isNegative,
    isSwiping,
    isOpen,
    isSave,
    toggleModal,
    isAnsweredCardsExist,
    onSwipeMove,
    onSwipeEnd,
    positiveSwipe,
    negativeSwipe,
    neutralSwipe,
    backSwipe,
    forwardSwipe,
    calculatePercentProgress,
    onSave,
    selectedCard,
  } = useViewController(onFeedbackSwipe);
  const currentGame = Game.game;

  useEffect(() => {
    const handleTouchMove = (e) => {
      if (e.cancelable) {
        e.preventDefault();
      }
    };

    document.body.addEventListener("touchmove", handleTouchMove, {
      passive: false,
    });

    return () => {
      document.body.removeEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
    };
  }, []);

  return (
    <div className="in-game-page-edit centering-page">
      <WrapperPage backBtn burgerMenu={!!token} loginBtn={!token}>
        <TopMobileModal toggleModal={toggleModal} isOpen={isOpen} />
        <Butterflies
          className="in-game-page-edit-butterflies"
          countEllipses={2}
        />
        <Ellipses className="in-game-page-edit-ellipses" countEllipses={1} />
        <div className="in-game-page-edit__main">
          <div className="in-game-page-edit__main__swipe-wrapper">
            <ProgressBar
              calculatePercentProgress={calculatePercentProgress}
              countCard={countCard}
              completedCards={completedCards}
            />
            {Game.cards.map((card, i) => {
              return (
                i === countCard && (
                  <div key={card.id} className="edit-main-swiper-wrapper">
                    <div
                      style={i === countCard ? mountedStyle : unmountedStyle}
                      className="in-game-page-edit__main__swipe-wrapper__wrapper"
                    >
                      {/*TODO оставил вдруг захотят вернуть свайп*/}
                      {/*<Swipe*/}
                      {/*  allowMouseEvents={true}*/}
                      {/*  onSwipeStart={onSwipeStart}*/}
                      {/*  onSwipeEnd={(event) => onSwipeEnd(event, card)}*/}
                      {/*  onSwipeMove={onSwipeMove}*/}
                      {/*  style={{*/}
                      {/*    transform: `translate(${Swiper.transform.x}px, ${Swiper.transform.y}px) rotate(${Swiper.transform?.rotate}deg)`,*/}
                      {/*  }}*/}
                      {/*  className={`in-game-page-edit__main__swipe-card ${*/}
                      {/*    isPositive && "positive-swipe-transform"*/}
                      {/*  }*/}
                      {/*${isNegative && "negative-swipe-transform"}*/}
                      {/*${isNeutral && "neutral-swipe-transform"}*/}
                      {/*`}*/}
                      {/*>*/}
                      {/*  <div className="in-game-page-edit__main__swipe-card__wrapper">*/}
                      {/*    {i === countCard && (*/}
                      {/*      <SwiperImage*/}
                      {/*        card={card}*/}
                      {/*        isNeutral={isNeutral}*/}
                      {/*        isNegative={isNegative}*/}
                      {/*        isPositive={isPositive}*/}
                      {/*        opacityCard={opacityCard}*/}
                      {/*      />*/}
                      {/*    )}*/}
                      {/*  </div>*/}
                      {/*</Swipe>*/}
                      <div>
                        <div className="in-game-page-edit__main__swipe-card__wrapper">
                          {i === countCard && (
                            <SwiperImage
                              card={card}
                              isNeutral={isNeutral}
                              isNegative={isNegative}
                              isPositive={isPositive}
                              opacityCard={opacityCard}
                            />
                          )}
                        </div>
                      </div>
                      <CardTitle card={card} i={i} countCard={countCard} />
                      <LastAnswer className="half-opacity" card={card} />
                    </div>
                    <SwiperActions
                      countCard={countCard}
                      isSwiping={isSwiping}
                      isToRight={false}
                      isNegative={false}
                      isNeutral={false}
                      isToTop={false}
                      isToLeft={false}
                      isPositive={false}
                      backSwipe={backSwipe}
                      positiveSwipe={positiveSwipe}
                      neutralSwipe={neutralSwipe}
                      negativeSwipe={negativeSwipe}
                      isAnsweredCardsExist={isAnsweredCardsExist}
                      forwardSwipe={forwardSwipe}
                      card={card}
                      selectedCard={selectedCard}
                      completedCards={completedCards}
                    />
                    <MobileModalLastAnswers card={card} />

                    <BaseButton
                      className={`${
                        (!selectedCard || isSave) &&
                        "in-game-page-edit__main__button_save--noactive"
                      } in-game-page-edit__main__button_save`}
                      onClick={onSave}
                    >
                      {isSave ? t("saved") : t("save")}
                    </BaseButton>
                  </div>
                )
              );
            })}
          </div>
          {/*<div className="in-game-page-edit__main__exit">*/}
          {/*  {currentGame && currentGame?.demo ? (*/}
          {/*    <BaseTextButton onClick={() => navigate(ROUTES.PAYMENT_PAGE)}>*/}
          {/*      {t("buy_game")}*/}
          {/*    </BaseTextButton>*/}
          {/*  ) : (*/}
          {/*    <BurgerMenu />*/}
          {/*  )}*/}
          {/*</div>*/}
        </div>
      </WrapperPage>
    </div>
  );
});
